import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Cash"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-cash',
    templateUrl: './icon-cash.component.html',
    styleUrls: ['./icon-cash.component.scss'],
    standalone: false
})
export class IconCashComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
